export default __webpack_public_path__ + "static/media/sec3.7cd088c0.jpeg";